import React from 'react';
import { MAX_CONTENT_LENGTH } from '@app/constants/socialMediaPosts';

type CardTextProps = {
    className?: string;
    content?: string;
    onMediaClick?: () => void;
};

const CardText = ({ className = '', content, onMediaClick }: CardTextProps) => {
    const truncatedContent = content
        ? content.length > MAX_CONTENT_LENGTH
            ? content.slice(0, MAX_CONTENT_LENGTH) + '...'
            : content
        : '';

    return (
        <div className={className} onClick={onMediaClick}>
            <div className="card-text__container">
                <div>
                    <p className="card-text__content">{truncatedContent}</p>
                </div>
            </div>
        </div>
    );
};

export default CardText;
